/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
	icon: {
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M2 5.5L3.21429 7L7.5 3"
					fill="none"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2 12.5L3.21429 14L7.5 10"
					fill="none"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2 19.5L3.21429 21L7.5 17"
					fill="none"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M22 19L12 19"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
				/>
				<path
					d="M22 12L12 12"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
				/>
				<path
					d="M22 5L12 5"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
				/>
			</svg>
		),
	},
	/**
	 * @see ./edit.js
	 */
	edit: Edit,

	/**
	 * @see ./save.js
	 */
	save,
} );
